import {
  AnnouncementDeleteDTO,
  AnnouncementDTO,
  MyAnnouncementDTO,
  PaginatorDTO
} from '@app/src/views/MyAccount/listAvailable/models/AnnouncementDTO';
import { AnnouncementModel, MyAnnouncementModel, PaginatorModel } from '@app/src/views/MyAccount/listAvailable/models/AnnouncementModel';

export const hydrateData = (data: MyAnnouncementDTO) => ({
  ads: hydrateAnnouncement(data.data),
  paginator: hydratePaginator(data.paginator)
} as MyAnnouncementModel);

const hydratePaginator = (data: PaginatorDTO) => ({
  currentPage: data.current_page,
  limitPage: data.limit_page,
  numPrintsPage: data.num_prints_page,
  numTotalPrints: data.num_total_prints,
  totalPages: data.total_pages
} as PaginatorModel);

const hydrateAnnouncement = (data: AnnouncementDTO[]): AnnouncementModel[] => data.map((item: AnnouncementDTO) => ({
  categoryId: item.category_id,
  categoryName: item.category_name,
  title: item.title,
  publicationDate: item.publication_date,
  dateCreate: item.date_create,
  operationType: item.operation_type,
  description: item.description,
  printDate: item.print_date,
  active: item.active,
  uniqueId: item.unique_id,
  type: item.type,
  adId: item.ad_id
} as AnnouncementModel));

export const hydrateDataSendForDelete = (data) => data.map((item) => {
  const current = item;
  delete item.checked;
  if (item && item.type === 'print') {
    return ({
      category_id: current.categoryId,
      unique_id: current.uniqueId,
      type: current.type
    })
  }
  return ({
    type: current.type,
    ad_id: current.adId
  }) as AnnouncementDeleteDTO
})